/**
 * Favicon Service - Ensures proper favicon display
 */
class FaviconService {
  constructor() {
    this.defaultIcon = '/logo-square.png';
  }

  /**
   * Set the favicon programmatically
   * @param {string} iconPath - Path to the icon file
   */
  setFavicon(iconPath = this.defaultIcon) {
    // Determine file type based on extension (now properly detecting PNG)
    const isSvg = iconPath.includes('.svg');
    const isPng = iconPath.includes('.png');

    console.log('🎯 Setting favicon:', iconPath, 'Type detected:', isSvg ? 'SVG' : (isPng ? 'PNG' : 'Unknown'));

    // Remove existing favicon links except our main one
    const existingLinks = document.querySelectorAll('link[rel*="icon"]:not(#favicon)');
    existingLinks.forEach(link => link.remove());

    // Update or create the main favicon
    let favicon = document.getElementById('favicon');
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.id = 'favicon';
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }

    // Set with cache busting
    const cacheBuster = '?v=' + Date.now();
    favicon.href = iconPath + cacheBuster;
    favicon.type = isSvg ? 'image/svg+xml' : 'image/png';

    // For PNG, set specific sizes, for SVG use 'any'
    favicon.sizes = isSvg ? 'any' : '32x32';

    // Create additional icon formats for broader compatibility
    this.createAdditionalIcons(iconPath, cacheBuster, isSvg);

    console.log('✅ Favicon updated to:', iconPath, 'Type:', favicon.type, 'Sizes:', favicon.sizes);
  }

  /**
   * Create additional icon links for broader browser support
   */
  createAdditionalIcons(iconPath, cacheBuster, isSvg) {
    // Apple touch icon
    const appleTouchIcon = document.createElement('link');
    appleTouchIcon.rel = 'apple-touch-icon';
    appleTouchIcon.href = iconPath + cacheBuster;
    appleTouchIcon.sizes = '180x180';
    document.head.appendChild(appleTouchIcon);

    // Standard sizes for PNG (create multiple sizes), for SVG just one with 'any'
    if (isSvg) {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/svg+xml';
      link.sizes = 'any';
      link.href = iconPath + cacheBuster;
      document.head.appendChild(link);
    } else {
      // For PNG, create specific sizes
      const sizes = ['16x16', '32x32', '48x48', '64x64', '128x128', '192x192', '512x512'];
      sizes.forEach(size => {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.sizes = size;
        link.href = iconPath + cacheBuster;
        document.head.appendChild(link);
      });
    }

    // Also set favicon.ico as fallback
    const faviconIco = document.createElement('link');
    faviconIco.rel = 'shortcut icon';
    faviconIco.href = '/favicon.ico' + cacheBuster;
    document.head.appendChild(faviconIco);
  }

  /**
   * Initialize favicon on app start
   */
  init() {
    this.setFavicon();
    console.log('🎯 Favicon service initialized');
  }
}

export default new FaviconService();